<main class="skiptranslate">
  <nz-alert *ngIf="data.isCensored" nzType="warning" [nzMessage]="agreement"></nz-alert>
  <ng-template #agreement>
    <span style="white-space: pre-line; font-weight: bold">
      {{ 'AUCTION.CONFIRM.AGREEMENT' | translate }}
    </span>
  </ng-template>
  <form nz-form [formGroup]="form" nzLayout="vertical">
    <nz-form-item *ngIf="data.isCensored">
      <nz-form-control>
        <label nz-checkbox formControlName="agree">
          {{ 'AUCTION.CONFIRM.I_AGREE' | translate }}
        </label>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzRequired>{{ 'AUCTION.CONFIRM.SUM' | translate }}:</nz-form-label>
      <nz-form-control>
        <input
          nz-input
          formControlName="price"
          type="number"
          appRestrictionsInput
          [blockNegative]="true"
          [resetNegative]="true"
          min="0"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="!data.isBuying">
      <nz-form-control>
        <label nz-checkbox formControlName="deferred">
          {{ 'AUCTION.DEFFERED_BID' | translate }}
        </label>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzRequired>{{ 'AUCTION.CONFIRM.COUNT' | translate }}:</nz-form-label>
      <nz-form-control>
        <input
          nz-input
          formControlName="quantity"
          type="number"
          appRestrictionsInput
          [blockNegative]="true"
          [resetNegative]="true"
          min="0"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label>{{ 'AUCTION.CONFIRM.COMMENT' | translate }}:</nz-form-label>
      <nz-form-control>
        <textarea nz-input rows="4" formControlName="message"></textarea>
      </nz-form-control>
    </nz-form-item>
  </form>

  <app-auction-reserve-amount
    [amount]="price.value"
    [quantity]="quantity.value"
    [auctionId]="data?.auctionId"
    [exchangeRate]="data?.exchangeRate"
  ></app-auction-reserve-amount>
</main>

<div *nzModalFooter>
  <div nz-row nzJustify="space-around">
    <div nz-col>
      <button
        nz-button
        [disabled]="data.isCensored && !form.value.agree"
        [nzLoading]="loading | async"
        nzSize="large"
        nzType="primary"
        (click)="trade()"
      >
        {{ (isBuying ? 'AUCTION.BUY' : 'AUCTION.PUT') | translate }}
      </button>
    </div>
  </div>
</div>
